import { PropsWithChildren, createContext, useState } from "react";
import React from "react";

export type CodePrintingState = {
    selectedStudents: string[];
    showSelection: boolean;
    students: string[];
};
type CodePrintingContext = [
    CodePrintingState,
    React.Dispatch<React.SetStateAction<CodePrintingState>>
];

const initialCodePrintingState: CodePrintingState = {
    selectedStudents: [],
    showSelection: false,
    students: [],
};
export const codePrintingContext = createContext<CodePrintingContext>([
    initialCodePrintingState,
    () => {},
]);

export const CodePrintingProvider = ({
    students,
    children,
}: PropsWithChildren<{ students: string[] }>) => {
    const state = useState<CodePrintingState>({
        ...initialCodePrintingState,
        students,
    });

    return (
        <codePrintingContext.Provider value={state}>
            {children}
        </codePrintingContext.Provider>
    );
};
